module.exports = __webpack_public_path__ + "static/img/statistice-user.a083c1be.png";